module.exports = __webpack_public_path__ + "media/images/athletes/1642-dafee52cfb8ebb3a1268dd2e340a88fc.png";